import React from 'react';
import autobind from 'autobind';
import { observer, inject } from 'mobx-react';

import { Scroller } from '@components/Scroller';

import { SubBlockItem, SubBlockItemProps } from './SubBlockItem';
import { EntryPage as EntryPageStore } from '@patient/ui/shared/store';
import { assertIsDefined } from '@utils/assertIsDefined';

interface Props extends SubBlockItemProps {
    subBlockIndex: number;
}

interface StoreProps {
    entryPage: EntryPageStore;
}

@observer
class Component extends React.Component<Props & StoreProps> {
    public render(): React.ReactNode {
        const {
            entryPage: { rightContentMenu },
            subBlockIndex,
        } = this.props;

        const block = rightContentMenu.getSubItem(subBlockIndex);
        assertIsDefined(block, `Right content menu has sub block ${subBlockIndex}`);

        return React.createElement(SubBlockItem, {
            title: block.title,
            isSelected: rightContentMenu.selectedSubItemIndex === subBlockIndex,
            onClick: this.handleItemClick,
        });
    }

    @autobind
    protected handleItemClick() {
        const {
            entryPage: { rightContentMenu },
            subBlockIndex,
        } = this.props;

        const block = rightContentMenu.getSubItem(subBlockIndex);
        assertIsDefined(block, `Right content menu has sub block ${subBlockIndex}`);

        Scroller.scrollTo({
            id: block.value,
        });

        rightContentMenu.selectedSubItemIndex = subBlockIndex;
    }
}

export const SubBlockItemContainer = inject<Props, StoreProps>(EntryPageStore.Name)(Component);
